import * as React from "react";
import axiosInstance from "../../Api/Axios";

import Select from "../../Components/Select";

const ClaimTypeSelect = (props) => {
  const { ...rest } = props;

  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/reclamation-types`)
      .then((response) => {
        setData(response.data.data.types || []);
      });
  }, []);

  return (
    <Select {...rest}>
      <option value=""></option>
      {data.map((reclamation) => {
        return (
          <option key={reclamation.id} value={reclamation.id}>
            {reclamation.name}
          </option>
        );
      })}
    </Select>
  );
};

export default ClaimTypeSelect;
